module.exports = __webpack_public_path__ + "static/media/web-development1.c42d3187.jpg";